import { createAsyncThunk } from '@reduxjs/toolkit';
import CategoryAPI from './services';

export const fetch = createAsyncThunk('category/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await CategoryAPI.fetchAll(params);

    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});
